// @flow
import React, { useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Slider from 'react-slick';
import { StringUtil } from 'utils/StringUtil';
import { useViewport } from 'components/templates/viewportProvider';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
//eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  data: {
    completedProjects: Object,
    sectionHeading: string,
  },
};

const CompletedProjectsMobile = (props: Props) => {
  const { height } = useViewport();
  const {
    completedProjects: { mobileData, mediaPath },
    sectionHeading,
  } = props.data;
  const [activeSlide, setActiveSlide] = useState(0);
  const [slider, setSlider] = useState();

  const settings = {
    variableWidth: false,
    dots: true,
    infinite: false,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    // fade: true,
    arrows: false,
    draggable: true,
    vertical: false,
    verticalSwiping: false,
    cssEase: 'cubic-bezier(0.77, 0, 0.175, 1)',
    // beforeChange: (current, next) => setActiveSlide(next),
    // initialSlide: activeSlide,
    appendDots: dots => (
      <div>
        <ul style={{ margin: '0px', padding: '0px' }}>{dots}</ul>
      </div>
    ),
    customPaging: i => <div className={'indicators'} />,
  };

  return (
    <div className={'mobile-section full'}>
      {mobileData.map((data, idx) => {
        const imageUrl = data.images;
        const description = StringUtil.sliceHtml(data.description);
        return (
          <div className={'section-content row'} key={idx} style={{ height }}>
            <Slider
              ref={c => setSlider(c)}
              {...settings}
              style={{ height, width: '100%' }}
            >
              {imageUrl.map((slides, idx) => {
                return (
                  <div className={'carousel-image'} key={idx}>
                    <img src={`${mediaPath.mobile}/${slides}`} alt={'image'} />
                  </div>
                );
              })}
            </Slider>
            <Row className={'content-row'}>
              <Col xs={{ span: 10 }} sm={{ span: 10 }}>
                <div className={'statements'}>
                  <span className={'title'}>{sectionHeading}</span>
                  <h2>{data.heading}</h2>
                  <p className={'description'}>{description}</p>
                </div>
              </Col>
            </Row>
          </div>
        );
      })}
    </div>
  );
};

export default CompletedProjectsMobile;
